import { useEffect } from "react";

const InputField = ({
  type,
  name,
  register,
  defaultValue,
  errors,
  label,
  autoComplete,
  valueAsNumber,
}) => {
  useEffect(() => {}, [defaultValue]);
  return (
    <>
      <div className="input-container">
        <label htmlFor={name} className="block text-text-1/90 font-medium">
          {label}
        </label>
        <input
          className="w-full px-3  border-b-2 text-base rounded-none bg-content border-bkg2 focus:outline-none focus:border-b-primary text-text-1/75"
          type={type}
          min={0}
          // placeholder={placeholder}
          autoComplete={autoComplete ? autoComplete : ""}
          {...register(name, { valueAsNumber })}
          defaultValue={defaultValue ? defaultValue : ""}
          // step={type === "number" ? 0.01 : ""}
        />
        {/* {errors && <p className="input-error-text">{errors.message}</p>} */}
        {
          <p className="text-red-400 text-xs text-wrap w-fit">
            {errors && errors.message} <span className="invisible">Sample</span>
          </p>
        }
      </div>
    </>
  );
};

export default InputField;
